module.exports = __webpack_public_path__ + "img/hr-logo-white.1a086676.png";